import VisibilitySensor from 'react-visibility-sensor'

import { readyToLoad } from 'app/components/common/reports/v3/hooks/useLazyLoading'

import styles from './CellLoadingController.scss'

type Props = {
  value: string
  lastRow: boolean
}

export const CellLoadingController = ({ value, lastRow }: Props) => {
  const handleVisible = (visible: boolean) => {
    if (visible) {
      readyToLoad()
    }
  }

  const result = <span className={styles.root}>{value}</span>

  return lastRow ? (
    <VisibilitySensor onChange={handleVisible} partialVisibility delayedCall>
      {result}
    </VisibilitySensor>
  ) : (
    result
  )
}
